<app-tool-backup-table
    [hasPagination]="false"
    [toolBackups]="toolBackups"
    [tableConfig]="tableConfig"
    (checkedTools)="onCheckedTools($event)">
</app-tool-backup-table>
